import { render } from "./edit-invoices.vue?vue&type=template&id=acd82952"
import script from "./edit-invoices.vue?vue&type=script&lang=js"
export * from "./edit-invoices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__